import React from 'react'
import { Popup, Segment } from 'semantic-ui-react'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import SwiperCore, { Pagination } from 'swiper/core'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import { PopupProps } from '../map/MapMarkers'
import SchemeInformation from '../scheme-information/SchemeInformation'

import './MapMarker.css'
import PlanningApplications from './PlanningApplications'
import { PlanningData } from './slice'
// install Swiper modules
SwiperCore.use([Pagination])

function PlanningMarkerPopup({ data, trigger }: PopupProps<PlanningData>) {
  return (
    <Popup
      position={'top center'}
      className={'planningMapPopup'}
      on={'click'}
      trigger={trigger}>
      <Segment.Group raised className={'markerSegmentContainer'}>
        <Segment attached="top" className={'planningMapPopupSegment'}>
          <h2 className="parcelDetailsAddress">{data.address}</h2>
          <p className="parcelDetailsLocationAndLot">
            {data.lotDetails ? data.lotDetails : 'UNAVAILABLE'}
          </p>
        </Segment>
        <Segment attached="bottom" className="planningMapPopupFieldsSegment">
          <Swiper slidesPerView={1} spaceBetween={30} loop={true} pagination={{
            'clickable': true,
            'renderBullet': function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>'
            },
          }} className="markerSwiper">
            <SwiperSlide>
              <div className={'planningSchemeInformation'}>
                <SchemeInformation planningData={data}/>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={'markerPlanningApps'}>
                {<PlanningApplications planningApps={data.planningApps} labelWidth={8}
                                       valueWidth={8}/>}
              </div>
            </SwiperSlide>
          </Swiper>
        </Segment>
      </Segment.Group>
    </Popup>
  )
}

export default PlanningMarkerPopup
